import { useRef } from 'react';
export var useTimeout = function useTimeout(delay) {
  var timeoutRef = useRef(null);
  var reset = function reset() {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(function () {
      timeoutRef.current = null;
    }, delay);
  };
  return {
    test: function test() {
      return !!timeoutRef.current;
    },
    reset: reset
  };
};